/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_SorterInputs */

const en_sidebar_sorter = /** @type {(inputs: Sidebar_SorterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Sorter`)
};

const ko_sidebar_sorter = /** @type {(inputs: Sidebar_SorterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키 정렬`)
};

const ja_sidebar_sorter = /** @type {(inputs: Sidebar_SorterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーソート`)
};

/**
* | output |
* | --- |
* | "Key Sorter" |
*
* @param {Sidebar_SorterInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_sorter = /** @type {((inputs?: Sidebar_SorterInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_SorterInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_sorter(inputs)
	if (locale === "ko") return ko_sidebar_sorter(inputs)
	return ja_sidebar_sorter(inputs)
});